import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  fetchReviewsBanner: null,
  fetchReviewsBannerStart: null,
  fetchReviewsBannerSuccess: ['reviewsBannerData'],
  fetchReviewsBannerFailure: null,

  fetchLatestReviews: ['pageNumber'],
  fetchLatestReviewsStart: null,
  fetchLatestReviewsSuccess: ['latestReviews'],
  fetchLatestReviewsFailure: null,

  fetchTopReviews: null,
  fetchTopReviewsStart: null,
  fetchTopReviewsSuccess: ['topReviews'],
  fetchTopReviewsFailure: null,

  fetchLaptops: null,
  fetchLaptopsStart: null,
  fetchLaptopsSuccess: ['laptops'],
  fetchLaptopsFailure: null,

  fetchMobiles: null,
  fetchMobilesStart: null,
  fetchMobilesSuccess: ['mobiles'],
  fetchMobilesFailure: null,

  fetchCameras: null,
  fetchCamerasStart: null,
  fetchCamerasSuccess: ['cameras'],
  fetchCamerasFailure: null,

  fetchAccessories: null,
  fetchAccessoriesStart: null,
  fetchAccessoriesSuccess: ['accessories'],
  fetchAccessoriesFailure: null,

  fetchBestOfLaptops: null,
  fetchBestOfLaptopsStart: null,
  fetchBestOfLaptopsSuccess: ['bestOfLaptops'],
  fetchBestOfLaptopsFailure: null,

  fetchBestOfMobiles: null,
  fetchBestOfMobilesStart: null,
  fetchBestOfMobilesSuccess: ['bestOfMobiles'],
  fetchBestOfMobilesFailure: null,

  fetchBestOfCameras: null,
  fetchBestOfCamerasStart: null,
  fetchBestOfCamerasSuccess: ['bestOfCameras'],
  fetchBestOfCamerasFailure: null,

  fetchBestOfAccessories: null,
  fetchBestOfAccessoriesStart: null,
  fetchBestOfAccessoriesSuccess: ['bestOfAccessories'],
  fetchBestOfAccessoriesFailure: null,

  fetchLaptopsReviews: ['pageNumber'],
  fetchLaptopsReviewsStart: null,
  fetchLaptopsReviewsSuccess: ['laptopsReviews'],
  fetchLaptopsReviewsFailure: null,

  fetchMobilesReviews: ['pageNumber'],
  fetchMobilesReviewsStart: null,
  fetchMobilesReviewsSuccess: ['mobilesReviews'],
  fetchMobilesReviewsFailure: null,

  fetchCamerasReviews: ['pageNumber'],
  fetchCamerasReviewsStart: null,
  fetchCamerasReviewsSuccess: ['camerasReviews'],
  fetchCamerasReviewsFailure: null,

  fetchAccessoriesReviews: ['pageNumber'],
  fetchAccessoriesReviewsStart: null,
  fetchAccessoriesReviewsSuccess: ['accessoriesReviews'],
  fetchAccessoriesReviewsFailure: null
});

export { Types, Creators };
